import { Box, Typography } from "@mui/material";
import { FlashIcon } from "../../assets/icons";
import style from "./style.module.scss";
import { DietaryTargetsResponse } from "../../openapi/client";
import { checkIf } from "../../utils";

interface IProps {
  dietaryTargets?: DietaryTargetsResponse;
}

export default function DietaryTargets(props: IProps) {
  const { dietaryTargets } = props;
  return (
    <div className={style.number_wrap}>
      <Box sx={{ display: "flex", gap: "4px" }}>
        <Typography sx={{ display: "flex", alignItems: "center", color: "text.blue" }}>
          <FlashIcon />
        </Typography>
        <div className={style.total}>
          {checkIf(dietaryTargets?.calories) ? `${dietaryTargets?.calories} kcal` : "-"}
        </div>
      </Box>

      <div className={style.values}>
        <div className={style.value}>
          <div className={style.quantity}>
            Pro: {checkIf(dietaryTargets?.protein) ? `${dietaryTargets?.protein}g` : "-"}
          </div>
        </div>
        <div className={style.value}>
          <div className={style.quantity}>Carb: {checkIf(dietaryTargets?.carb) ? `${dietaryTargets?.carb}g` : "-"}</div>
        </div>
        <div className={style.value}>
          <div className={style.quantity}>Fat: {checkIf(dietaryTargets?.fat) ? `${dietaryTargets?.fat}g` : "-"}</div>
        </div>
      </div>
    </div>
  );
}
